// extracted by mini-css-extract-plugin
export var dropdown = "_uh-0";
export var imageWrapper = "_uh-3";
export var itemNameContainer = "_uh-1";
export var productImage = "_uh-2";
export var spinnerWrapper = "_uh-4";